import RoleLogic from './logic'
const landingHandler = (LocalStorage, landingPages) => {
  const role = RoleLogic(LocalStorage)
  return landingPages[role]
}

export default landingHandler
